import { render } from "./FormContactView.vue?vue&type=template&id=28c5f230"
import script from "./FormContactView.vue?vue&type=script&lang=js"
export * from "./FormContactView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__